import React, { Component } from 'react'

import { Card, Form, Input, Cascader, Button, message } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons';

import LinkButton from '../../components/link-button'
import PicturesWall from '../business/pictures-wall'
import RichTextEditor from '../business/rich-text-editor'

//import { connect } from 'react-redux'
import memoryUtils from '../../utils/memoryUtils'
import { req_list_category, req_edit_product, req_add_product } from '../../api'


const Item = Form.Item
const { TextArea } = Input;

export default class ProductModify extends Component {

    // 基礎通用參數 //////////////////////////////////////////////    

    state = {
        options: []
    }

    constructor(props) {
        super(props)

        //獲取子組件(pictures-wall)實體方法
        this.picturesfiles = React.createRef()
        //獲取子組件(rich-text-editor)實體方法
        this.editor = React.createRef()
    }

    UNSAFE_componentWillMount() {
        // 取出協帶的數據(來自product)
        const product = this.props.location.state
        this.isUpdate = !!product
        this.product = product || {}
    }

    componentDidMount() {
        this.api_list_categorys(0)
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_list_categorys = async (nidParentCategory) => {
        const token = memoryUtils.user.token
        const result = await req_list_category(nidParentCategory, token)

        //console.log(result)
        if (result.total > 0) {
            const categorys = result.data
            if (nidParentCategory === 0) {
                //一級列表
                this.initOptions(categorys)
            } else {
                // 二級列表
                return categorys
            }
            //console.log(categorys)
        }
    }

    api_modify_product = async (product) => {
        if (this.isUpdate) {
            product.Uid = this.product.Uid
            product.ProductNid = this.product.ProductNid
            product.condition = "BASE"
            const result = await req_edit_product(product, memoryUtils.user.token)
            if (result.status === "success") {
              //  console.log(result)
                message.success(result.message)
                this.props.history.goBack()
            } else {
                message.error(result.message)
            }
        } else {
            const result = await req_add_product(product, memoryUtils.user.token)        
            if (result.status === "success") {
                message.success(result.message)
                this.props.history.goBack()
            } else {
                message.error(result.message)
            }
        }
    }

    // 數據配置設定 ////////////////////////////////////////////// 

    initOptions = async (categorys) => {
        const options = categorys.reduce((row_pre, row) => {
            row_pre.push({ value: row.nidCategory, label: row.categoryName, isLeaf: row.childrenCounts > 0 ? false : true })
            return row_pre
        }, [])

        // 在[更新狀態]須預載二級類別
        const { isUpdate, product } = this
        if (isUpdate && product.CatalogParentNid !== 0) {
            const subCategorys = await this.api_list_categorys(product.CatalogParentNid)
            const childrenOptions = subCategorys.reduce((row_pre, row) => {
                row_pre.push({ value: row.nidCategory, label: row.categoryName, isLeaf: row.childrenCounts > 0 ? false : true })
                return row_pre
            }, [])
            const targetOption = options.find(option => option.value === product.CatalogParentNid)
            targetOption.children = childrenOptions
        }

        this.setState({ options })
        //console.log(options)
    }

    loadData = async selectedOptions => {
        // 得到選擇的Option對象
        const targetOption = selectedOptions[selectedOptions.length - 1];

        targetOption.loading = true;
        const subCategorys = await this.api_list_categorys(targetOption.value)
        targetOption.loading = false;

        if (subCategorys && subCategorys.length > 0) {
            const childrenOptions = subCategorys.reduce((row_pre, row) => {
                row_pre.push({ value: row.nidCategory, label: row.categoryName, isLeaf: row.childrenCounts > 0 ? false : true })
                return row_pre
            }, [])
            targetOption.children = childrenOptions
        }
        else {
            targetOption.isLeaf = true
        }
        this.setState({ options: [...this.state.options] })
    };

    // 操作互動處理 //////////////////////////////////////////////

    validator_price = (rule, value, callback) => {
        if (value * 1 >= 0) {
            callback()
        } else {
            callback('必須大於0')
        }
    }

    onFinish = (values) => {
        //console.log('Success:', values);
        const { ProductName, ProductDetails, ProductPrice, CategoryIds } = values

        const images = this.picturesfiles.current.output_files()
        const Appendices = images.reduce((item_pre, item) => {
            item_pre.push({ Uid: item })
            return item_pre
        }, [])

        const RecordDescription = this.editor.current.output_text()

        const product = {
            ProductName: ProductName,
            ProductDetails: ProductDetails,
            ProductPrice: ProductPrice,
            CatalogNid: CategoryIds[CategoryIds.length - 1],
            Appendices: Appendices,
            RecordDescription: RecordDescription
        }
        this.api_modify_product(product)
    };

    /////////////////////////////////////////////////////////////

    render() {
        const { isUpdate, product } = this
        const CategoryIds = []
        if (isUpdate) {
            //console.log(product)
            if (product.CatalogParentNid === 0) {
                CategoryIds.push(product.CatalogNid)
            } else {
                CategoryIds.push(product.CatalogParentNid)
                CategoryIds.push(product.CatalogNid)
            }
        }

        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 18 }
        }

        const title = (
            <span>
                <LinkButton><ArrowLeftOutlined style={{ color: 'green', marginRight: 15, fontSize: 20 }} onClick={() => this.props.history.goBack()} /></LinkButton>
                物件{isUpdate ? '修改' : '新增'}
            </span>
        )

        return (
            <Card title={title} className='product-details'>
                <Form
                    {...formItemLayout}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Item
                        label="物件名稱"
                        name="ProductName"
                        initialValue={product.ProductName}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入名稱' },
                        ]}
                    >
                        <Input placeholder="輸入物件名稱" />
                    </Item>
                    <Item
                        label="物件描述"
                        name="ProductDetails"
                        initialValue={product.ProductDetails}
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入相關描述' },
                        ]}
                    >
                        <TextArea showCount maxLength={250} autoSize={{ minRows: 2, maxRows: 6 }} placeholder="輸入相關描述" />
                    </Item>
                    <Item
                        label="物件價值"
                        name="ProductPrice"
                        initialValue={product.ProductPrice}
                        rules={[
                            { validator: this.validator_price },
                        ]}
                    >
                        <Input type="number" placeholder="僅輸入數字" addonAfter='元' />
                    </Item>
                    <Item
                        label="分類"
                        name="CategoryIds"
                        initialValue={CategoryIds}
                        rules={[
                            { required: true, message: '必須選擇一項分類' },
                        ]}
                    >
                        <Cascader options={this.state.options} loadData={this.loadData} />
                    </Item>
                    <Item
                        label="附件圖片"
                        name="Appendices"
                    >
                        <PicturesWall ref={this.picturesfiles} edit_input_images={product.Appendices}></PicturesWall>
                    </Item>
                    <Item
                        label="物件詳情"
                        name="RecordDescription"
                        labelCol={{ span: 4 }}
                        wrapperCol={{ span: 18 }}
                    >
                        <RichTextEditor ref={this.editor} edit_input_richtext={product.RecordDescription} />
                    </Item>
                    <Item>
                        <Button type='primary' htmlType="submit">送出</Button>
                    </Item>
                </Form>
            </Card>
        )
    }
}
